import MerchantLogoPlaceholder from '@cohort/components-xps/components/MerchantLogoPlaceholder';
import {getImageUrl, Sizes} from '@cohort/shared/utils/media';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import {useMerchantContext} from '@cohort/wallet/hooks/useMerchantContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';

const MerchantInfos: React.FC = () => {
  const {hasDarkBg} = useThemeContext();
  const merchant = useMerchantContext();

  return (
    <div className="flex h-full flex-col justify-center">
      {merchant.logoFileKey ? (
        <img
          title={`${merchant.name} logo`}
          className={classNames(
            'mx-auto mb-5 inline-block aspect-square h-20 w-20 rounded-xl border bg-white md:mx-0',
            hasDarkBg ? 'border-white/30' : 'border-black/30'
          )}
          src={getImageUrl(import.meta.env.COHORT_ENV, merchant.logoFileKey, {
            h: Sizes.XS,
            w: Sizes.XS,
          })}
        />
      ) : (
        <div className="mx-auto mb-5 md:mx-0">
          <MerchantLogoPlaceholder size={80} merchantName={merchant.name} shape="square" />
        </div>
      )}
      <h3
        className={classNames(
          'mx-auto text-2xl font-bold leading-6 md:mx-0',
          hasDarkBg ? 'text-white' : 'text-black/90'
        )}
      >
        {merchant.name}
      </h3>
      <p
        className={classNames(
          'prose mx-5 mt-2 max-w-4xl text-center text-sm sm:mx-auto sm:text-left md:mx-0',
          hasDarkBg && 'prose-invert'
        )}
        dangerouslySetInnerHTML={{
          __html: merchant.description ?? '',
        }}
      />
    </div>
  );
};

export default MerchantInfos;
